import { useTranslation } from "react-i18next";
import { useBasicComponents } from "./useBasicComponent";

export const useNeo4jConfig = (action = "create", defaultValues = {}) => {
  const { t } = useTranslation();
  const { core, memory, dataDisk, nodegroup } = useBasicComponents(
    action,
    defaultValues,
  );

  const neo4jColumns = () => {
    const group = "neo4j";
    return [
      // Editable: Neo4jHelm.overrideValues() reads this to build the pod's nodeSelector at
      // deploy time, and UpdateNeo4jStep/Neo4jHelm.update_more() patch the live StatefulSet's
      // nodeSelector and delete the pod to reschedule it when this changes.
      nodegroup({ group }),
      // No replicas field, unlike Gitea/Druid: Neo4jHelm never overrides
      // Component.is_update_replicas() (standalone only, see helms/Neo4jHelm.py), so a
      // replicas value submitted through the update form would be silently ignored. Enabling
      // and disabling the whole server goes through separate actions (scaleupHelm/
      // scaledownHelm), not this field.
      core({ group }),
      memory({ group }),
      dataDisk({ group }),
      {
        title: t("config.instance.form.heapInitialSize", "Heap Initial Size"),
        dataIndex: `${group}.heapInitialSize`,
        width: "sm",
      },
      {
        title: t("config.instance.form.heapMaxSize", "Heap Max Size"),
        dataIndex: `${group}.heapMaxSize`,
        width: "sm",
      },
      {
        title: t("config.instance.form.pagecacheSize", "Pagecache Size"),
        dataIndex: `${group}.pagecacheSize`,
        width: "sm",
      },
    ];
  };

  const neo4jSchema = [
    {
      title: t("config.instance.form.neo4j", "Neo4j"),
      valueType: "group",
      columns: neo4jColumns(),
    },
  ];

  return neo4jSchema;
};
